import Axios from "axios";

export const changePassword = (username, formdata) => {
    return Axios.put(`/api/user/${username}/password`, formdata);
};
